// Shared thickness options and foam density mappings for all cushion products

export const THICKNESS_OPTIONS = [
  { value: 5, labelCm: '5cm', labelMm: '50mm' },
  { value: 7.5, labelCm: '7.5cm', labelMm: '75mm' },
  { value: 10, labelCm: '10cm', labelMm: '100mm' },
  { value: 12.5, labelCm: '12.5cm', labelMm: '125mm' },
  { value: 15, labelCm: '15cm', labelMm: '150mm' },
];

// Maps thickness (cm) → available foam density IDs
export const FOAM_BY_THICKNESS = {
  4:    ['35-200'],
  5:    ['36-100', '36-130'],
  7.5:  ['36-100', '36-130'],
  8:    ['35-200'],
  10:   ['36-100', '36-130'],
  12.5: ['36-100', '36-130'],
  15:   ['36-100', '36-130'],
};

// Foam density details (keyed by ID for quick lookup)
export const FOAM_DENSITIES = {
  '35-200': {
    id: '35-200',
    name: '35-200 (Firm Support)',
    shortName: '35-200',
    description: 'Supportive medium-density foam with a firm feel (200N). Great for seat cushions that see daily use.',
  },
  '36-100': {
    id: '36-100',
    name: '36-100 (Soft Comfort)',
    shortName: '36-100',
    description: 'High-density foam with a plush, soft feel (100N). Ideal for relaxed, sink-in seating comfort.',
  },
  '36-130': {
    id: '36-130',
    name: '36-130 (Medium Feel)',
    shortName: '36-130',
    description: 'High-density foam with a balanced medium-firm feel (130N). Our most versatile option for general use.',
  },
};
